import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { db } from "../../../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const AdminProjectsList = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState("all");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projectsRef = collection(db, "projects");
        const snapshot = await getDocs(projectsRef);
        const projectsList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProjects(projectsList);
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const filteredProjects = projects.filter((project) =>
    selectedTab === "all" ? true : project.status === selectedTab
  );

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Admin: Project Management
      </Typography>

      {/* Tabs for filtering projects */}
      <Tabs
        value={selectedTab}
        onChange={(event, newValue) => setSelectedTab(newValue)}
        sx={{ mb: 3 }}
      >
        <Tab label="All" value="all" />
        <Tab label="Draft" value="draft" />
        <Tab label="Submitted" value="submitted" />
        <Tab label="Approved" value="approved" />
      </Tabs>

      {/* Loading Indicator */}
      {loading ? (
        <CircularProgress />
      ) : (
        <List>
          {filteredProjects.length > 0 ? (
            filteredProjects.map((project) => (
              <ListItem
                key={project.id}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  borderBottom: "1px solid #ddd",
                  paddingBottom: 1,
                }}
                onClick={() => navigate(`/admin/projects/${project.id}`)}
              >
                <ListItemText
                  primary={project.title}
                  secondary={`Budget: $${project.budget} | Status: ${project.status}`}
                />
                <EditIcon color="primary" />
              </ListItem>
            ))
          ) : (
            <Typography>No projects found.</Typography>
          )}
        </List>
      )}
    </Container>
  );
};

export default AdminProjectsList;
